import React from 'react';

const NoTenantAccess: React.FC = () => {
  return (
    <div className='no-tenant-access-div'>
      <h1>No Tenant Access</h1>
      <p>
        Please contact your IT administrator to verify access to trade
        compliance data.
      </p>
    </div>
  );
};

export default NoTenantAccess;
